import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';

const MainLayout = ({ children }) => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const isSpecialPage = ['/cart', '/profile', '/product'].includes(location.pathname);
  const hideNavFooter = ['/login', '/signup'].includes(location.pathname);

  return (
    <div className="relative min-h-screen bg-white">
      {!hideNavFooter && <Header />}
      <main 
        className={`
          ${!isHomePage && !hideNavFooter ? (isSpecialPage ? 'pt-[118px]' : 'pt-[100px]') : ''} 
          ${!isHomePage && !hideNavFooter ? 'sm:pt-[120px]' : ''} 
          ${isHomePage ? 'overflow-x-hidden' : ''}
        `}
      >
        {children}
      </main>
      {!hideNavFooter && <Footer />}
    </div>
  );
};

export default MainLayout;
